const messages = {
  name: 'Admin users |||| Admin users',
  fields: {
    name: 'Name',
    surname: 'Surname',
    email: 'Email',
    role: 'Role',
    status: 'Status',
    origin: 'Origin',
    password: 'Temporary password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
  },
  columns: {
    actions: 'Actions',
  },
  filters: {
    name: 'Name',
    surname: 'Surname',
    email: 'Email',
  },
  roles: {
    SuperUser: 'SuperUser',
    Maintenance: 'Maintenance',
  },
  status: {
    active: 'Active',
    blocked: 'Blocked',
  },
  badges: {
    realm: 'Realm role',
    realmHelp:
      'Access comes from a realm role, shared with the other Roommatik products. Change it in Keycloak, not here.',
    service: 'Service',
    serviceHelp: 'Keycloak service account (integration), not a person.',
    noProfile: 'No profile',
    noProfileHelp:
      'No row in the users table: they can sign in, but "My profile" fails to load. Editing them here fixes it.',
  },
  actions: {
    addUser: 'Add admin user',
    changePassword: 'Change password',
    block: 'Block (keeps the role, cannot sign in)',
    unblock: 'Unblock',
    revoke: 'Revoke admin access',
    revokeConfirm: 'Revoke access',
  },
  dialog: {
    create: 'New admin user',
    edit: 'Edit admin user',
    changePassword: 'Change password for %{email}',
  },
  help: {
    superUserOnly:
      'Only a SuperUser can view and manage admin users.',
    intro:
      'Who can sign in to THIS backoffice. Access is granted by a Keycloak role, which is why admins created by hand in its console also show up here. Portal and contact-center users of a customer live in User management.',
    roleSuperUser: 'Full access, including these admin users.',
    roleMaintenance:
      'Support: manages accounts end to end, but not providers, licenses, pricing or admin users.',
    passwordOptional:
      'Optional. Leave it empty and Keycloak emails them a link to set it themselves.',
    temporaryPassword:
      'Temporary password: Keycloak asks them to change it on sign-in. At least 12 characters with an uppercase, a lowercase, a number and a symbol.',
    realmRoleLocked:
      'Access comes from a realm role shared with the other Roommatik products. Their details can be edited, but the role must be changed in Keycloak: removing it here could lock them out of other applications.',
  },
  revoke: {
    title: 'Revoke admin access for %{email}?',
    content:
      "The backoffice roles on the notify client are removed. Their Keycloak user is NOT deleted: the realm is shared with the other Roommatik products and deleting it would lock them out of all of them. You can grant access again at any time.",
  },
  validation: {
    emailRequired: 'Email is required',
    emailInvalid: 'Invalid email',
    passwordRequired: 'Password is required',
    passwordPattern:
      'At least 12 characters, with an uppercase, a lowercase, a number and a symbol',
    confirmPasswordRequired: 'Please confirm the password',
    confirmPasswordMismatch: 'Passwords do not match',
  },
  notifications: {
    created: 'Admin user created',
    updated: 'Admin user updated',
    blocked: 'User blocked',
    unblocked: 'User unblocked',
    revoked: 'Access revoked',
    passwordSet: 'Password updated',
  },
};

export default messages;
